import React from "react";
import CommonMatchResult from "components/CommonMatchResult";

const TournamentMatchResult = (props, context) => (
  <CommonMatchResult {...props} matchInfo={props.tournamentMatchInfo} />
);

export default TournamentMatchResult;
